<div class="card p-2 mb-4">
  <div class="d-flex">
    <img class="benefitImage rounded" src="{{ benefit.ImageFileName | contentImage: '1' }}" />
    <div class="w-100 ps-3 pe-2">
      <h6 class="text-secondary font-size-14 fw-bold">{{ benefit.Name }}</h6>
      <h6 class="font-size-12">Exp: {{ benefit.EndDate | date: 'longDate' }}</h6>
      <p class="cursor-pointer font-size-12 fw-bold" (click)="openInfoModal(benefit)">Read More...</p>
      <div class="w-100">
        <ng-container [ngSwitch]="classifyStatusOfBenefit">
          <ng-container *ngSwitchCase="BUTTON_STATUS.AddBenefit">
            <button
              *ngIf="claimLimit != null && numberClaimed < claimLimit"
              (click)="openInfoModal(benefit)"
              class="btn btn-benefit btn-secondary btn-benefit-add rounded w-100 fw-bold"
            >
              {{ 'add.benefit' | translate }}
            </button>
          </ng-container>

          <ng-container *ngIf="benefit.ShowWhenOutOfStock">
            <button
              *ngSwitchCase="BUTTON_STATUS.OutOfStock"
              class="btn btn-benefit btn-secondary btn-benefit-out-of-stock rounded w-100 fw-bold disabled"
            >
              {{ 'benefit.button.out.of.stock' | translate }}
            </button>
          </ng-container>

          <ng-container *ngIf="benefit.ShowWhenNotActive">
            <button
              *ngSwitchCase="BUTTON_STATUS.ComingSoon"
              class="btn btn-benefit btn-secondary btn-benefit-comming-soon rounded w-100 fw-bold disabled"
            >
              {{ 'benefit.button.coming.soon' | translate }}
            </button>
            <button
              *ngSwitchCase="BUTTON_STATUS.Expiried"
              class="btn btn-benefit btn-outline-secondary btn-benefit-expiried rounded w-100 fw-bold disabled"
            >
              {{ 'benefit.button.expiried' | translate }}
            </button>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
